<div>
    <ng-content #trigger></ng-content>

    <p-menu #menu [model]="[]" [popup]="true" (onHide)="onVisibilityChange(false)" (onShow)="onVisibilityChange(true)"
        [styleClass]="'custom-menu'" [baseZIndex]="100000" [autoZIndex]="true" appendTo="body"
        [style]="{ 'max-height': '60vh', overflow: 'auto' }">

        <ng-template #start>
            <div class="custom-menu-container max-w-[20rem]  ">
                @if(isInSubMenu && currentParentItem) {
                <div class="sticky-back-header">
                    <div class="custom-menu-item flex items-center gap-1 back-button-item"
                        (click)="navigateBack($event)">
                        <span class="menu-icon">
                            <app-icon type="arrow-left" source="lucide" size="sm" class="cursor-pointer" />
                        </span>
                        <div class="menu-content cursor-pointer">
                            <div class="menu-label">{{ currentParentItem.label }}</div>
                        </div>
                    </div>
                    <div class="border-t border-gray-100 mx-2 my-1"></div>
                </div>
                }
                @if(search()) {
                <div class="px-2 py-2">
                    <div class="relative">
                        <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange($event)"
                            placeholder="Search..."
                            class="w-full px-3 py-2 pl-9 pr-3 text-sm border border-gray-300 rounded-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            (click)="$event.stopPropagation()" />
                        <app-icon type="search" source="lucide" size="sm"
                            class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                    </div>
                </div>
                <div class="border-t border-gray-100 mx-2 my-1"></div>
                }
                <div [class]="'menu-items-scrollable ' + class()">
                    @for (item of displayedItems; track item.label) {
                    @if (item.isGroupHeader) {
                    <div
                        class="px-3 pt-3 pb-1 text-xs font-semibold uppercase tracking-wider text-gray-400 select-none">
                        {{ item.label }}
                    </div>
                    } @else {
                    <div class="cursor-pointer custom-menu-item hover:bg-gray-100 rounded-base" [ngClass]="{
                        'border border-blue-200 bg-blue-50': isItemSelected(item),
                        'opacity-50 cursor-not-allowed pointer-events-auto': item.disabled
                    }" (click)="onItemClick($event, item)">
                        <ng-container *ngIf="itemTemplate(); else defaultItemContent">
                            <ng-container
                                *ngTemplateOutlet="itemTemplate()!; context: { $implicit: item }"></ng-container>
                        </ng-container>
                        <ng-template #defaultItemContent>

                            <span class="menu-badge" *ngIf="item.badgeNumber != null">{{ item.badgeNumber }}</span>

                            <span class="menu-icon" *ngIf="item.icon && !item.badgeNumber">
                                <app-icon [type]="item.icon" [source]="item.iconSource || IconSourceEnum.PRIMENG"
                                    [size]="item.iconSize || 'default'" [class]="item.class">
                                </app-icon>
                            </span>

                            <div class="menu-content max-w-full overflow-x-auto">
                                <div [class]="'menu-label ' + (item.class || '')">{{ item.label }}</div>
                                <div class="menu-description" *ngIf="item.description">
                                    {{ item.description }}
                                </div>
                            </div>
                            <span class="menu-arrow" *ngIf="item.subOptions && item.subOptions.length > 0">
                                <app-icon type="chevron-right" size="sm" source="lucide"></app-icon>
                            </span>

                            <span class="menu-check"
                                *ngIf="!item.subOptions && item.type !== MenuItemType.TOGGLE && item.type !== MenuItemType.BUTTON && isItemSelected(item)">
                                <app-icon type="check" size="sm" source="lucide"></app-icon>
                            </span>
                            @if(item.type === MenuItemType.TOGGLE) {
                            <app-toggle [(ngModel)]="item.toggleState" (onChange)="onToggleChange(item, $event)"
                                (click)="$event.stopPropagation()"
                                class="menu-toggle-switch flex items-center primary-toggle">
                            </app-toggle>
                            }
                            @if(item.type === MenuItemType.BUTTON) {
                            <app-button [label]="item.buttonLabel || ''" [icon]="item.buttonIcon || ''"
                                [loading]="item.buttonLoading || false"
                                [iconSource]="item.iconSource || IconSourceEnum.PRIMENG"
                                [disabled]="item.disabled || false" [class]="item.buttonClass || ''" [size]="'sm'"
                                (clicked)="onButtonClick($event, item)">
                            </app-button>
                            }
                        </ng-template>
                    </div>
                    }
                    }@empty {
                    <div class="text-center text-gray-500 py-4">No items found</div>
                    }
                </div>
            </div>
        </ng-template>
    </p-menu>
</div>